export const getChangesCount = (obj: { [key: string]: boolean }) => {
  let count = 0;
  for (const k in obj) {
    if (obj[k]) {
      count++;
    }
  }
  return count;
};
